import { apiUtils } from '../utils/api';
import { API_ENDPOINTS } from '../constants';

const { ROOT, OPEN_COUNT } = API_ENDPOINTS.FALL_EVENTS;

export const getFallEvents = (params = {}) => apiUtils.get(ROOT, { params });
export const getOpenFallEventCount = () => apiUtils.get(OPEN_COUNT);
export const updateFallEvent = (id, payload) => apiUtils.patch(`${ROOT}${id}/`, payload);
